var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item-wrapper"},[_c('module-title',{attrs:{"type":"m"}},[_vm._v("订单数据")]),_c('v-chart',{ref:"pieChart",staticClass:"chart",attrs:{"option":_vm.option,"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }